export default "__VITE_ASSET__BNjzgId6__"